function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
import { InputDecoratorsBaseInput, InputDecoratorsBox, InputDecoratorsContainer } from "./base";
import { multiRef } from '@isyc-react/core/utils/reference';
export const InputDecorators = /*#__PURE__*/React.forwardRef((props, ref) => {
  const {
    value,
    onBlur,
    onChange,
    onFocus,
    readOnly,
    disabled,
    size,
    error,
    focusInputOnDecoratorsFocus = false,
    prefix,
    suffix,
    inputRef,
    className,
    input
  } = props;
  const baseRef = React.useRef(null);
  const focusInput = React.useCallback(() => {
    if (baseRef.current) baseRef.current.focus();
  }, []);
  return /*#__PURE__*/React.createElement(InputDecoratorsContainer, {
    size: size,
    error: error,
    onFocus: e => {
      if (focusInputOnDecoratorsFocus) focusInput();
      onFocus && onFocus(e);
    },
    onBlur: onBlur,
    disabled: disabled,
    readOnly: readOnly,
    className: className,
    ref: ref,
    tabIndex: -1
  }, prefix && /*#__PURE__*/React.createElement(InputDecoratorsBox, null, prefix), /*#__PURE__*/React.createElement(InputDecoratorsBaseInput, _extends({
    ref: multiRef(inputRef, baseRef),
    disabled: disabled,
    readOnly: readOnly,
    value: value,
    onChange: e => {
      onChange && onChange(e.target.value, e);
    }
  }, input)), suffix && /*#__PURE__*/React.createElement(InputDecoratorsBox, null, suffix));
});